import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// import { QUICK_FILTERS } from '../../components/QuickFilters/constants';
import { useStyles } from './styles';
import withBreadcrumbs from '../App/HOCs/withBreadcrumbs';
import CategoryCard from '../../components/CategoryCard';
// import QuickFilters from '../../components/QuickFilters';

const CategoryPage = ({ category }) => {
	const { t } = useTranslation(['category', 'categoryDetails']);
	const classes = useStyles();
	const location = useLocation();

	const buildProductsPagePath = filterParams => {
		const params = filterParams ? '?' + filterParams : '';
		const cleanPathname = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;

		return cleanPathname + '/products' + params;
	};

	if (!category) return <Redirect to="/" />;

	if (!category.hasOwnProperty('categories') || !Array.isArray(category.categories) || category.categories.length < 1) {
		return <Redirect to={buildProductsPagePath(category.filterParams)} />;
	}

	return (
		<Grid container direction="column" alignItems="center">
			<Grid item xs={9} className={classes.descriptionContainer}>
				<Typography variant="h4" gutterBottom>
					{t('category:' + category.id + '.title')}
				</Typography>

				<Typography variant="h6" color="textSecondary">
					{t('category:' + category.id + '.subtitle')}
				</Typography>

				<Typography variant="body1" className={classes.text}>
					{t('categoryDetails:' + category.id + '.description')}
				</Typography>
			</Grid>

			<Grid item>
				{/* QUICK_FILTERS[category.id] &&
                    QUICK_FILTERS[category.id].length > 0 && (
                        <QuickFilters categoryId={category.id} />
                    )*/}
			</Grid>

			<Grid item xs={10} container spacing={3}>
				{category.categories.map(subcat => (
					<Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={subcat.id + '-category-tile'}>
						<CategoryCard categoryId={subcat} />
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

CategoryPage.propTypes = {
	category: PropTypes.object.isRequired
};

export default withBreadcrumbs(CategoryPage);
